import Text from 'components/commons/text';
import { styled } from 'styles';
import typography from 'styles/typography';

export const StyledGalleryDialog = styled('div', {
  backgroundColor: '$white',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 16,
  width: '100%',
  maxWidth: 800,
  overflow: 'hidden',
});

export const StyledGalleryHeader = styled('div', {
  padding: 16,
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  backgroundColor: '$primary',
  alignItems: 'center',
});

export const StyledGalleryContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  minHeight: 300,
  '@md': {
    flexDirection: 'row',
    minHeight: 400,
  },
});

export const GalleryTitleText = styled(Text, {
  color: '$white',
  userSelect: 'none',
  ...typography.headline5,
  '@md': {
    ...typography.headline4,
  },
});

export const GallerySlideShow = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  padding: 16,
});

export const ImageList = styled('div', {
  display: 'flex',
  width: '100%',
  padding: 16,
  borderTop: '1px solid $dbGray1',
  overflowX: 'scroll',
  '@md': {
    overflowX: 'hidden',
    overflowY: 'scroll',
    borderTop: 'none',
    borderLeft: '1px solid $dbGray1',
    minWidth: 150,
    width: 'auto',
    flexDirection: 'column',
    height: 'auto',
  },
});

export const ImageThumbnailContainer = styled('div', {
  width: 93,
  height: 70,

  m: 4,
  borderRadius: 4,
  userSelect: 'none',
  cursor: 'pointer',
  overflow: 'hidden',
  position: 'relative',
  '@md': {
    width: 180,
    height: 120,
  },
});

export const ImageContainer = styled('div', {
  userSelect: 'none',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  borderRadius: 8,
  position: 'relative',
});

export const PictureText = styled(Text, {
  color: '$typeGray',
  userSelect: 'none',
  ...typography.body5,
  '@md': {
    ...typography.body4,
  },
});
